var _excluded = ["title", "required", "description", "placeholder", "fieldName", "validation", "onChange", "className", "wrapperClassName", "disabled", "descriptionAboveInput"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Field } from 'formik';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import withMapping from '../../../Context/withMapping';
import GenericFormElement from '../GenericFormElement';
import { useExtendedFormikContext } from '../FormikWrapper';
import './style.scss';
export var TextField = function TextField(props) {
  var title = props.title,
    required = props.required,
    description = props.description,
    placeholder = props.placeholder,
    fieldName = props.fieldName,
    validation = props.validation,
    onChange = props.onChange,
    className = props.className,
    wrapperClassName = props.wrapperClassName,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    descriptionAboveInput = props.descriptionAboveInput,
    restProps = _objectWithoutProperties(props, _excluded);
  var type = props.type || 'text';
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleValidation = function handleValidation(value) {
    if (validation) {
      return validation(value);
    }
    if (required && (value === undefined || value === null || value === '')) {
      return t(['webform.components.text_field.required', 'webform.required', 'webform_required']);
    }
  };
  var handleChange = function handleChange(e) {
    var handleChange = props.handleChange;
    if (handleChange) {
      handleChange(e);
    }
    if (onChange) {
      onChange(e);
    }
  };
  var _useExtendedFormikCon = useExtendedFormikContext(),
    values = _useExtendedFormikCon.values,
    errors = _useExtendedFormikCon.errors,
    touched = _useExtendedFormikCon.touched,
    displayRequiredIndicator = _useExtendedFormikCon.displayRequiredIndicator;

  // https://www.drupal.org/project/webform_rest/issues/3093890

  // Some Webform Fields (e.g. webform_address, webform_name) consist of composite fields, which are objects.
  // drupal/webform_rest does not handle that yet. Keys and values are stringified, like so: 'address][address'
  //
  // So for errorhandling on composite webform fields, we need some extra logic.

  var nestedFieldname = fieldName.split('][');
  var isTouched;
  if (Object.keys(touched).length && touched[nestedFieldname[0]]) {
    isTouched = nestedFieldname[1] ? touched[nestedFieldname[0]][nestedFieldname[1]] : touched[fieldName];
  }
  var error;
  if (Object.keys(errors).length && errors[nestedFieldname[0]]) {
    error = nestedFieldname[1] ? errors[nestedFieldname[0]][nestedFieldname[1]] : errors[fieldName];
  }
  var value = nestedFieldname[1] ? values[nestedFieldname[0]][nestedFieldname[1]] : values[fieldName];
  var errorId = "".concat(props.fieldName, "--error");
  var descriptionId = "".concat(props.fieldName, "--description");
  return /*#__PURE__*/React.createElement(GenericFormElement, {
    className: c('TextField', wrapperClassName),
    title: title,
    required: required,
    description: description,
    fieldName: fieldName,
    touched: isTouched,
    error: error,
    errorId: errorId,
    descriptionId: descriptionId,
    displayRequiredIndicator: displayRequiredIndicator,
    descriptionAboveInput: descriptionAboveInput
  }, /*#__PURE__*/React.createElement(Field, _extends({}, restProps, {
    className: c(className, {
      'error': error && isTouched
    }),
    id: fieldName,
    name: fieldName,
    type: type,
    value: value,
    placeholder: placeholder,
    validate: handleValidation,
    onKeyUp: handleChange,
    disabled: disabled,
    required: required,
    "aria-describedby": "".concat(errorId, " ").concat(descriptionId),
    "aria-invalid": Boolean(error && isTouched)
  })));
};
export default withMapping(TextField);